import * as React from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import fishSnifferLogo from "../images/assets/fishsnifferlogo.png"

const Header = ({ siteTitle, onToggleSidebar, navLinks }) => (
  <header className="site-header">
    <div className="header-container"> 
      <div className="header-left"> 
        {/* Hamburger menu toggle */}
        <button
          onClick={onToggleSidebar}
          className="sidebar-toggle" 
          aria-label="Toggle Menu"
        >
          ☰ 
        </button>
        {/* Site Title */}
        <h1 className="site-title"> 
          <Link to="/">
            <img src={fishSnifferLogo} alt="The Fish Sniffer Logo" className="site-logo" />
          </Link>
        </h1>
      </div>

      <div className="header-right"> 
        {/* Desktop Navigation (populated from navLinks prop) */}
        <nav className="desktop-nav">
          <ul>
            {navLinks && navLinks.map((link) => ( // Check if navLinks exists
              <li key={link.name}>
                <Link to={link.path}>{link.name}</Link>
              </li>
            ))}
          </ul>
        </nav>
        {/* Subscribe Button */}
        <Link to="/subscribe/" className="subscribe-button">Subscribe</Link>
        {/* We'll hide the hamburger menu on desktop via CSS */} 
      </div>
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
  onToggleSidebar: PropTypes.func.isRequired,
  navLinks: PropTypes.arrayOf(PropTypes.shape({ // Add prop type validation
      name: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
  })),
}

Header.defaultProps = {
  siteTitle: ``, 
  navLinks: [], // Default to empty array
}

export default Header
